import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CalculatorLead } from './lead.model';

@Injectable({ providedIn: 'root' })
export class RechnerLeadService {
  private readonly http = inject(HttpClient);

  /**
   * Übergibt den Lead an das Backend. Das Backend legt ihn in Pipedrive an
   * und verschickt die Rechnung als PDF – das Frontend kennt diese Systeme
   * bewusst nicht.
   */
  submit(lead: CalculatorLead): Promise<{ id: string }> {
    return firstValueFrom(
      this.http.post<{ id: string }>('/api/rechner/lead', lead),
    );
  }
}
